import * as React from "react";
import TextField from "@material-ui/core/TextField";
import WithdrawalBatchesContainer from "app/components/AppComponents/Withdrawals/WithdrawalBatchesContainer";
import { RouteComponentProps } from "react-router";
import { ChildProps, MutationFunc } from "react-apollo";
import * as moment from "moment";

type GqlSubmitMutationResult = {
  submit_withdrawal_batch: {
    id: string;
  };
};
type GqlNamedMutations = {
  submitWithdrawalBatchMutation: MutationFunc<GqlSubmitMutationResult>;
};

type Props = ChildProps<
  BOComponentProps & RouteComponentProps & GqlNamedMutations,
  GqlSubmitMutationResult
>;

type State = {
  createdAtFrom: string;
  createdAtTo: string;
};

class WithdrawalsBatches extends React.Component<Props, State> {
  state = {
    createdAtFrom: null,
    createdAtTo: null
  };

  componentDidMount() {
    this.props.setHeader({
      title: "Wallet Withdrawal Batches",
      description: "SnapScan Wallet Withdrawal Batches"
    });
  }

  onChangeFromDate(yyyyMmDd) {
    this.setState({
      createdAtFrom: moment(yyyyMmDd, "YYYY-MM-DD").toISOString()
    });
  }

  onChangeToDate(yyyyMmDd) {
    this.setState({
      createdAtTo: moment(yyyyMmDd, "YYYY-MM-DD").toISOString()
    });
  }

  render() {
    return (
      <section
        id="Wallet_Withdrawal_Bacthes_
      List"
        className="padded"
      >
        <h3
          style={{
            borderBottom: "1px solid rgb(204, 204, 204)",
            fontWeight: 400,
            display: "flex",
            alignItems: "center",
            marginTop: 0
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start"
            }}
          >
            <TextField
              type="date"
              placeholder="From"
              onChange={event => this.onChangeFromDate(event.target.value)}
              style={{
                width: "200px",
                marginRight: "10px"
              }}
            />
            <TextField
              type="date"
              placeholder="To"
              onChange={event => this.onChangeToDate(event.target.value)}
              style={{
                width: "200px",
                marginRight: "10px"
              }}
            />
          </div>
        </h3>

        <WithdrawalBatchesContainer
          name={"wallet.withdrawals.batches"}
          createdAtFrom={this.state.createdAtFrom}
          createdAtTo={this.state.createdAtTo}
        ></WithdrawalBatchesContainer>
      </section>
    );
  }
}

export default WithdrawalsBatches;
